import { motion } from "motion/react";
import Seo from "../components/Seo";
import InstagramFeed from "../components/InstagramFeed";
import CtaBlobs from "../components/CtaBlobs";
import { fadeUp, springSoft, staggerContainer, viewportOnce } from "../lib/motion";
import { PREINSCRIPTION_URL } from "../data/site";

export default function Activites() {
  return (
    <>
      <Seo
        path="/nos-activites"
        title="Nos activités"
        description="Ateliers musicaux, sorties forêt-musées-piscine, événements en crèche, éveil sensoriel… Découvrez le quotidien des enfants dans nos micro-crèches La La Land en Normandie."
      />

      <section className="bg-cream pt-6 md:pt-10 pb-6 md:pb-8">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center">
            <h1 className="font-display text-3xl md:text-5xl font-semibold text-ink leading-tight">
              Nos activités
            </h1>
            <p className="mt-2 text-ink-soft max-w-2xl mx-auto leading-snug text-base md:text-lg">
              Musique, sorties, événements en crèche, éveil sensoriel…
              la vie quotidienne dans nos micro-crèches.
            </p>
          </div>

          <motion.div
            className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3"
            variants={staggerContainer()}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
          >
            {[
              { tone: "bg-sage-soft", title: "La musique", text: "Comptines, instruments, intervenante hebdomadaire." },
              { tone: "bg-honey-soft", title: "Les sorties", text: "Forêt, musées, piscine et balades découverte." },
              { tone: "bg-terra-soft", title: "Événements en crèche", text: "Fêtes, ateliers parents-enfants, temps forts réguliers." },
              { tone: "bg-muted", title: "Éveil sensoriel", text: "Manipulation, peinture, pâte à sel, transvasement." },
            ].map((p) => (
              <motion.article
                key={p.title}
                variants={fadeUp}
                whileHover={{ y: -5 }}
                transition={springSoft}
                className={`${p.tone} rounded-2xl px-4 py-3 shadow-soft-sm transition-shadow hover:shadow-soft-md`}
              >
                <h3 className="font-display text-sm md:text-base font-semibold text-ink leading-tight">
                  {p.title}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-ink-soft leading-snug">
                  {p.text}
                </p>
              </motion.article>
            ))}
          </motion.div>
        </div>
      </section>

      <InstagramFeed compact />

      <section className="py-8 md:py-12">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="relative overflow-hidden bg-gradient-to-br from-sage to-sage-hover text-white rounded-4xl p-10 md:p-16 shadow-soft-lg">
            <CtaBlobs />
            <div className="relative">
              <h2 className="font-display text-3xl md:text-5xl font-semibold tracking-tight max-w-2xl">
                Envie d'en savoir plus&nbsp;?
              </h2>
              <p className="mt-4 text-lg opacity-95 max-w-xl">
                Pré-inscrivez-vous, nous revenons vers vous sous 48h.
              </p>
              <div className="mt-8 flex flex-wrap gap-3">
                <a
                  href={PREINSCRIPTION_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-terra hover:bg-terra-hover text-white px-6 py-3 rounded-xl font-medium transition active:scale-[0.97]">
                    Pré-inscription
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
